<template>
  <span
    class="user-presence-indicator"
    :class="`user-presence-indicator--${status}`"
    :title="label"
    :aria-label="label"
    data-testid="user-presence-indicator"
  />
</template>

<script setup lang="ts">
import { useI18n } from '@/common/composables/useI18n'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useUserPresenceStore } from '@/stores/userPresence'

const { t } = useI18n()
const { status } = storeToRefs(useUserPresenceStore())

const label = computed(() => {
  switch (status.value) {
    case 'away':
      return t('platform.userPresence.away')
    case 'offline':
      return t('platform.userPresence.offline')
    default:
      return t('platform.userPresence.online')
  }
})
</script>

<style scoped lang="scss">
.user-presence-indicator {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex: 0 0 auto;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.35);
}

.user-presence-indicator--online {
  background: #22c55e;
}

.user-presence-indicator--away {
  background: #ef4444;
}

.user-presence-indicator--offline {
  background: #111827;
}
</style>
